import Text from '../Base/Text/Text';
import { joinClasses } from '../../Utils/className.util';
import React from 'react';
import { TagModel } from '../../Models/TagModel';

// @ts-ignore
import styles from './Tag.module.scss';

interface Props {
	label: string;
	className?: string;
	id?: string;
	onClick?: (tag: TagModel) => void;
}

const Tag: React.FC<Props> = props => {
	const { label, className = '', id = '', onClick } = props;
	const handleClick = () => {
		onClick?.({
			id,
			label,
		});
	};

	return (
		<div className={joinClasses([styles.tag, className])} onClick={handleClick}>
			<Text tx={label} />
		</div>
	);
};

export default Tag;
